export default __webpack_public_path__ + "e4dc1edbe543f351f7c643a69ef88a78.png";